import { error } from './error';

export const state = {
  error: {
    ...error,
  },
};
